import { get as t } from "theme-ui";
const o = {
  position: "relative",
  display: "inline-flex",
  p: (i) => i.spacing(0.75),
  gap: (i) => i.spacing(0.25),
  bg: "secondary",
  borderRadius: "sm",
  "&[data-orientation=vertical]": {
    flexDirection: "column"
  }
}, e = {
  all: "unset",
  cursor: "pointer",
  position: "relative",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  columnGap: 1,
  py: (i) => i.spacing(0.75),
  px: 4,
  borderRadius: (i) => i.spacing(1.5),
  lineHeight: "body",
  color: "secondaryText",
  transition: (i) => `${t(i, "transitions.all")}, visibility 0ms`,
  ":hover": {
    color: "primary"
  },
  ":focus": {
    outline: "none"
  },
  ":focus-visible": (i) => ({
    ...i.outline({ color: "primary", offset: -0.5, radius: "xxl" })
  }),
  "&[data-state=on]": {
    color: "primary"
  },
  ":disabled": {
    cursor: "default",
    pointerEvents: "none",
    color: "disabledText"
  }
}, n = {
  position: "absolute",
  bg: "white",
  borderRadius: (i) => i.spacing(1.5),
  transition: (i) => `${t(i, "transitions.all")}, visibility 0ms`
}, s = {
  color: "lightGray3",
  transition: (i) => `${t(i, "transitions.all")}, visibility 0ms`,
  '&[data-orientation="vertical"]': {
    alignSelf: "center",
    height: 4
  }
}, a = {
  segmentedControl: o,
  segmentedControlItem: e,
  segmentedControlIndicator: n,
  segmentedControlSeparator: s
};
export {
  a as segmentedControlsTheme
};
